import * as React from "react"
import { Inbox } from "lucide-react"
import { cn } from "../../lib/utils"

interface EmptyProps extends React.HTMLAttributes<HTMLDivElement> {
  description?: React.ReactNode
  image?: React.ReactNode
}

const Empty = React.forwardRef<HTMLDivElement, EmptyProps>(
  ({ className, description = "No data", image, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex flex-col items-center justify-center py-8 text-center",
          className
        )}
        {...props}
      >
        {image || (
          <Inbox className="h-12 w-12 text-muted-foreground/50 mb-3" />
        )}
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
    )
  }
)

Empty.displayName = "Empty"

export { Empty }
